import react from "react";
import "../../../styles/styles.css";
import "../../../../../styles/global.css";
import ProfileLink from "./ProfileLink";
import { icons } from "../../../../../constants";

const ProfileNavBar = ({ t, setActiveTab, activeTab }) => {
  console.log("ProfileNavBar rendered with activeTab:", activeTab);
  return (
    <div className="profile-navbar">
      <ProfileLink
        text={t("PROFILE")}
        isActive={activeTab === "user_info"}
        src={icons.profile}
        src_dark={icons.profile_dark}
        handleClick={setActiveTab}
        value={"user_info"}
      />
      <ProfileLink
        text={t("CHANGE_PASSWORD")}
        isActive={activeTab === "change_password"}
        src={icons.change_password}
        src_dark={icons.change_password_dark}
        handleClick={setActiveTab}
        value={"change_password"}
      />
    </div>
  );
};
export default ProfileNavBar;
